import { render, staticRenderFns } from "./EChartDesempenho.vue?vue&type=template&id=5bf6af4e&scoped=true"
import script from "./EChartDesempenho.vue?vue&type=script&lang=js"
export * from "./EChartDesempenho.vue?vue&type=script&lang=js"
import style0 from "./EChartDesempenho.vue?vue&type=style&index=0&id=5bf6af4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf6af4e",
  null
  
)

export default component.exports